import { render } from "./ChartDisplay.vue?vue&type=template&id=32c50be0"
import script from "./ChartDisplay.vue?vue&type=script&lang=js"
export * from "./ChartDisplay.vue?vue&type=script&lang=js"

import "./ChartDisplay.vue?vue&type=style&index=0&id=32c50be0&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__